export const m = {
    "location":"Location",
    "logout":"Logout",
    "alert":{
        "reminder":"Prompt",
        "confirm":"OK",
        "cancel":"Cancel",
        "changeTip":"Sure to edit？",
        "deleteConfirm":"Are you sure to delete？",
        "changeConfirm":"Are you sure about the change?",
        "addConfirm":"Are you sure to add it?",
        "saveConfirm":"Are you sure to save it?",
        "handle":"Are you sure?",
        "logout":"Are you sure you want to log out of this account?",
        "updateUser":"Are you sure to update user info?",
        "submit":"Are you sure to submit?",
        "error":"Operation failed",
        "success":"Operation successful",
        "addSuccess":"Adding successful",
        "addError":"Adding failed",
        "saveSuccess":"Saving successful",
        "saveError":"Saving failed",
        "changeSuccess":"Changing successful",
        "changeError":"Changing failed",
        "deleteSuccess":"Deleting successful",
        "deleteError":"Deleting failed",
        "updateSuccess":"Updating successful",
        "updateError":"Updating failed",
        "codeSuccess":"Code send successful",
        "codeResetSuccess":"Password reset successful, please log in.",
        "tip1":"All contents related to the machine will be deleted.  check whether to unbind the machine?",
        "canceled": "Undo",
        cancelDelete: 'The deletion has been cancelled',
        "phoneError": 'Phone format error'

    },
    "index":{
        "index":"Index",
        "userManage":"User management",
        "device":{
            "title":"Machine",
            "bindDevice":"Machine list",
            "deviceList":"All user machine list"
        },
        "chart":{
            "title":"Curve",
            "myChart":"Curve list",
            "recommendChart":"Recommend curve",
            "collChart":"Collection curve",
            "userChart":"All user curve",
            "ourChart":"My curve",
            "clear":"Empty",
            "all": "All curveList"
        },
        "bean":{
            "title":"Storage",
            "myBean":"Storage condition",
            "factoryRecommend":"Factory recommend",
            "userBean":"All user storage"
        },
        "cup":{
            "title":"Cupping",
            "cupEvaluate":"Cup list",
            "myCupEvaluate":"My cup evaluate",
            "userCupEvaluate":"All user cupping list"
        },
        "setting":{
            "title":"Settings",
            "accountManage":"Accounts management",
            "quickEventManage":"Quick event manage",
            "systemSetting":"System settings",
            "userGuide":"User guide",
            "about":"About  h b",
            "userManage":"User management",
            "settingDeviceType":"Machine type manageme",
            "company":"Company",
            "address":"Address",
            "all":"All",
            "user":"User name",
            "userDetail":"User details",
            "tempUnit":"Temp unit",
            "weightUnit":"Weight unit"
        }
    },
    "common": {
        "reset": "Reset"
    },
    "login":{
        "sysName":"Backgroud management system",
        "rememberMe":"Remember",
        "login":"Login",
        "placeholder":{
            "userName":"Please enter username",
            "password":"Please enter password",
            "password2":"Please enter password again",
            "phone":"Please enter phone",
            "email":"Please enter email",
            "code":"Please enter verification code"
        },
        "forgetPassword":"Forgot password",
        "register":"Sign up",
        "tabPwd":"Username login",
        "tabCode":"Phone login",
        "tabEmailCode":"Email login",
        "phoneValid":"Phone verification",
        "emailValid":"Email verification",
        "getCode":"Get code",
        "getEmailCode":"Get email code",
        "licence": "Licence",
        phoneError: 'Phone format error',
        emailError:'Email format error'
    },
    "deviceIndex":{
        "reportUpload":"Machine report upload",
        "deviceTypeDetail":"Machine type details",
        "deviceList":"Machine list",
        "deviceInfo":"Machine info",
        "selectedDevice":"Selected machine",
        "deviceState":"Machine state",
        "beanTemper":"Bean temp",
        "inletAirTemperature":"Airflow temp",
        "environmentTemper":"Drum temp",
        "outWindTemper":"Exhaust temp",
        "beanInfo":"Bean info",
        "beanKind":"Bean kind",
        "beanWeight":"Bean weight",
        "loadNewMessage":"Load new message",
        "MaintainNewMsg":" maintain new msg",
        "maintainHistoryMsg":"Maintain history msg",
        "heating":"Heating",
        "airflow":"Airflow",
        "drum":"Drum",
        "cooling":"Cooling",
        "table":{
            "createTime":"Createdate",
            "content":"Content",
            "operation":"Operation"
        }
    },
    "userList":{
        "userList":"User list",
        "userTable":{
            "avatar":"Avatar",
            "username":"Username",
            "phone":"Phone",
            "email":"Email",
            "operation":"Operation",
            "createtime":"Createdate"
        },
        "tabs":{
            "beanList":"Bean list",
            "deviceList":"Machine list",
            "reportList":"Report list",
            "commentList":"Cup evaluate list"
        },
        "table":{
            "bean":{
                "name":"Name",
                "stock":"Stock",
                "createTime":"Createdate",
                "productArea":"Area",
                "handleMethod":"Handle method",
                "manor":"Manor",
                "country":"Country",
                "price":"Price",
                "altitude":"Altitude",
                "waterPercent":"Water percent",
                "supplier":"Supplier",
                "level":"Grade",
                "kind":"Species",
                "supplierContact":"Contact",
                "buyLink":"Buy link",
                "beanReport":"Bean report"
            },
            "device":{
                "name":"Name",
                "deviceType":"Machine type",
                "systemSeriesNum":"System series no",
                "createTime":"Createdate",
                "deviceStatus":"Machine status",
                "runTimeLog":"Running log",
                "maintainLog":"Maintain log",
                "bakeTime":"Bake time",
                "runTime":"Run time"
            },
            "report":{
                "name":"Name",
                "reportColor":"Degree",
                "reportLevel":"Grade",
                "type":"Kind"
            },
            "cupEvaluate":{
                "cupEvaluate":"Cupping",
                "name":"Name",
                "color":"Degree",
                "feedback":"Feedback",
                "score":"Score",
                "level":"Grade",
                "operation":"Operation",
                "look":"Look"
            }
        }
    },
    "deviceManage":{
        "bindDevice":{
            "name":"Name",
            "type":"Type",
            "systemSeriesNum":"Machine serial no.",
            "deviceSeriesNum":"Machine no.",
            "no":"No.",
            "bindTime":"Bind time",
            "createTime":"Createdate",
            "deviceStatus":"Machine status",
            "deviceLocation":"Machine location",
            "bakeTime":"Bake time",
            "runTimeLength":"Running time",
            "runTimeLog":"Running log",
            "maintainLog":"Maintain log",
            "notUpload":"Not uploaded",
            "curveList":"Curve list",
            "runLog":"Running log",
            "roastLog":"Roasting log",
            "maintenanceReminder":"Maintenance reminder",
            "addMaintenanceReminder":"Add",
            "editMaintenanceReminder":"Edit maintenance reminder",
            "maintenanceHistory":"Maintenance log",
            "addMaintenanceHistory":"Add",
            "editMaintenanceHistory":"Edit maintenance log",
            "alarmLog":"Alarm log",
            "duration":"Duration",
            "date":"Date",
            "timeHour":"Time(h)",
            "star":"Star level",
            "content":"Content",
            "triggerCondition":"Trigger conditions",
            "tableType":"Type",
            "count": "Count",
            "operation":{
                "name":"Operation",
                "detail":"Details",
                "unbind":"Unbind",
                "addMaintain":"Add maintain",
                "edit":"Edit",
                "delete":"Delete"
            },
            "button":{
                "bindBtn":"Binding"
            },
            "dialog":{
                "return":"Return",
                "bindDialog":{
                    "seriesNumber":"Machine no.",
                    "placeholder":"Please enter the machine no.",
                    "placeholder2":"Please enter the machine name",
                    "title":"Binding machine",
                    "bindBtn":"Binding",
                    "return":"Return",
                    "cancel":"Cancel",
                    "confirm":"OK"
                },
                "runTimeDialog":{
                    "title":"Running log",
                    "createTime":"Createdate",
                    "runTime":"Run time",
                    "bakeTime":"Bake time",
                    "index":"Index",
                    "timeLength":"Time length",
                    "date":"UploadDate",
                    "all":"All",
                    "return":"Return"
                },
                "maintainDialog":{
                    "tabMaintainLog":{
                        "title":"Maintain log",
                        "currentDevice":"Current machine",
                        "deviceStatus":"Machine status",
                        "index":"Index",
                        "user":"Worker",
                        "items":"Items",
                        "solution":"Content",
                        "date":"Date",
                        "detail":"Detail"
                    },
                    "tabMaintainNewMsg":{
                        "title":"Maintain new msg",
                        "date":"Date",
                        "content":"Content",
                        "loadBtn":"Load new msg",
                        "loadNewMsg":"Load new msg"
                    },
                    "historyTab":{
                        "title":"History msg",
                        "deleteBatch":"Delete batch",
                        "date":"Date",
                        "content":"Content"
                    }
                },
                "maintainDetailDialog":{
                    "title":"Maintain detail",
                    "type":"Type",
                    "user":"User",
                    "items":"Items",
                    "solution":"Solution",
                    "return":"Return"
                },
                "addMaintainDialog":{
                    "title":"Maintain detail",
                    "type":"Type",
                    "user":"User",
                    "items":"Items",
                    "solution":"Solution",
                    "return":"Return"
                },
                "deviceDetailDialog":{
                    "title":"Machine detail info",
                    "name":"Name",
                    "deviceModel":"Machine model",
                    "systemSeriesNum":"System series no",
                    "bindTime":"Bind time",
                    "deviceStatus":"Machine status",
                    "runTimeLength":"Running time",
                    "maintainLog":"Maintain log",
                    "deviceLocation":"Machine location",
                    "bakeTime":"Bake time length",
                    "copy":"Copy"
                }
            }
        },
        "deviceList":{
            "name":"Name",
            "type":"Model",
            "systemSeriesNum":"System series no",
            "bindTime":"Bind time",
            "createTime":"Createdate",
            "deviceStatus":"Machine status",
            "deviceLocation":"Machine location",
            "runTimeLog":"Running log",
            "maintainLog":"Maintain log",
            "button":{
                "all":"All",
                "search":"Search",
                "addDevice":"Add",
                "ascending":"Ascending",
                "descending":"Descending"
            },
            "options":{
                "searchOptions":{
                    "deviceName":"Machine name",
                    "serialNumber":"Serial number",
                    "systemSeriesNum":"System series num"
                },
                "orderOptions":{
                    "createTime":"Createdate",
                    "deviceType":"Machine type"
                }
            },
            "dialog":{
                "bindDialog":{
                    "seriesNumber":"Series num",
                    "title":"Binding machine",
                    "bindBtn":"Binding",
                    "return":"Return"
                },
                "runTimeDialog":{
                    "runTime":"Run time",
                    "bakeTime":"Bake time",
                    "index":"Index",
                    "timeLength":"Time length",
                    "date":"Date",
                    "all":"All",
                    "return":"Return"
                },
                "maintainDialog":{
                    "tabMaintainLog":{
                        "title":"Maintain log",
                        "currentDevice":"Current machine",
                        "deviceStatus":"Machine status",
                        "index":"Index",
                        "user":"User",
                        "items":"Items",
                        "solution":"Solution",
                        "date":"Date",
                        "detail":"Detail"
                    },
                    "tabMaintainNewMsg":{
                        "title":"Maintain new msg",
                        "date":"Date",
                        "content":"Content"
                    },
                    "historyTab":{
                        "title":"History msg",
                        "deleteBatch":"Delete batch",
                        "date":"Date",
                        "content":"Content"
                    }
                },
                "maintainDetailDialog":{
                    "title":"Maintain detail",
                    "type":"Type",
                    "user":"User",
                    "items":"Items",
                    "solution":"Solution",
                    "return":"Return"
                }
            }
        },
        "deviceDetial":{
            "user":"User name",
            "roastDate":"Date",
            "addCollect":"Add collection",
            "cancelCollect":"Cancel collection",
            "addRecommend":"Add recommended",
            "cancelRecommend":"Cancel recommended",
            "coffeeBeans":"Coffee beans",
            "cfName":"Name",
            "cfLevel":"Grade",
            "cfOpreate":"Process",
            "cfOpreate2":"Process",
            "cfDate":"Date",
            "cfWeight":"Weight",
            "cfAllWeight":"Total weight",
            "season":"Season",
            "kind":"Species",
            "kind2":"Kind"
        }
    },
    "chart":{
        "chart":"Curve",
        "chartSelect":"Select curve",
        "chartList":"Curve list",
        "btn":{
            "all":"All",
            "train":"Training",
            "draw":"Draw",
            "import":"Import",
            "newImport":"Import",
            "newDraw":"New draw"
        },
        "table":{
            "name":"Name",
            "color":"Degree",
            "level":"Grade",
            "kind":"Classes",
            "date":"Date",
            "owner":"Owner",
            "duration":"Duration",
            "machineName":"Machine name",
            "search":"Search",
            "cancel":"Cancel",
            "confirm":"OK",
            "placeholder1":"Enter the report name",
            "placeholder2":"Enter the report comments",
            "placeholder3":"Please enter the search criteria",
            "label1":"Report name",
            "label2":"Report remark",
            "curveImport":"Import curve",
            "back":"Back",
            "select":"Select report",
            "uploadTip":"Import JSON format, other formats have been blocked and not selectable.",
            "add":"Add",
            "score":"score"
        },
        "chartDetail":{
            "title":"Curve detail",
            "color":"Degree",
            "reportName":"Name",
            "level":"Grade",
            "type":"Classes",
            "temper":"Temper",
            "reportKind":"Report classes",
            "beanName":"Bean name",
            "beforeWeight":"Before weight",
            "afterWeight":"After weight",
            "unit":"Unit of temperature",
            "tabAllPoint":"All point",
            "beanTemperPoint":"Bean point",
            "ror":"ROR",
            "environmentTemper":"Environment temper",
            "outWind":"Out wind",
            "inWind":"In wind",
            "eventName":"Event name",
            "temperRate":"Temper",
            "temperRate1":"Temper rate",
            "occurrenceTime":"Occurrence time"
        },
        "wind":"Wind",
        "fire":"Fire",
        "speed":"Speed",
        "addChart":"Add curve"
    },
    "commentDetail":{
        "title":"Coffee cupping detail",
        "date":"Date",
        "roast":"Degree",
        "dryFragrant":"Aroma",
        "flavor":"Flavor",
        "taste":"Aftertaste",
        "acid":"Acidity",
        "mellow":"Body",
        "consistency":"Consistency",
        "balance":"Balance",
        "clean":"Clean",
        "sweetness":"Sweetness",
        "overallEvaluation":"Overall",
        "cupping":"Cupping Score",
        "defects":"Defects",
        "finalScore":"Final score",
        "scoreStandard":"Scoring Criteria",
        "saveChange":"Save changes",
        "delete":"Delete",
        "remark":"Notes",
        "time":"Date",
        "name":"Name",
        "add":"Add",
        "select":"Select curve",
        "dry":"Dry",
        "break":"Break",
        "inputDescription":"Input description",
        "submit":"Submit",
        "strength":"Strength",
        "high":"High",
        "low":"Low",
        "degree":"Degree",
        "thin":"Thin",
        "heavy":"Heavy",
        "development":"Development",
        "chocolate":"Chocolate",
        "candy":"Candy",
        "orange":"Orange",
        "flavorDescription":"Flavor description",
        "description":"Description",
        "underdeveloped":"Underdeveloped",
        "overdeveloped":"Overdeveloped",
        "baked":"Baked",
        "faced":"Faced",
        "scoreDescription":"Score description",
        "noEffect":"No effect",
        "aLittleBit":"A little bit",
        "palpable":"Palpable",
        "overwhelming":"Overwhelming",
        "scoringInstructions":"Scoring instructions",
        "good":"Good",
        "veryGood":"Very good",
        "excellent":"Excellent",
        "outstanding":"Outstanding",
        "user":"User"
    },
    "cupEvaluate":{
        "table":{
            "choose":"Choose",
            "cupEvaluate":"Cupping",
            "name":"Name",
            "owner":"Owner",
            "color":"Degree",
            "feedback":"Feedback",
            "score":"Score",
            "level":"Grade",
            "operation":"Operation",
            "look":"Look",
            "edit":"Edit"
        },
        "cupList":"Cup list",
        "detailDialogTitle":"Cup detail",
        "editDialogTitle":"Edit cup"
    },
    "bean":{
        "table":{
            "name":"Name",
            "owner":"Owner",
            "stock":"Stock",
            "addTime":"Createdate",
            "productArea":"Area",
            "handleMethod":"Handle method",
            "manor":"Manor",
            "country":"Country",
            "price":"Price",
            "altitude":"Altitude",
            "unit":"Meter",
            "waterPercent":"Moisture content",
            "supplier":"Supplier",
            "level":"Grade",
            "kind":"Varietal",
            "supplierContact":"Contact",
            "buyLink":"Buy link",
            "createTime":"Createdate",
            "chanji":"Season"
        },
        "addBeanBtn":"Add bean",
        "beanAllWeight":"Bean all weight",
        "beanKind":"Bean kind",
        "beanDetailDialog":"Bean details",
        "beanUsedTop10":"Bean used top10",
        "addRecommend":"Add recommended",
        "cancelRecommend":"Cancel recommended"
    },
    "accountManage":{
        "phone":"Phone",
        "username":"Username",
        "email":"Email",
        "oldPassword":"Original password",
        "newPassword":"New password",
        "checkPassword":"Confirm password"
    },
    "quickEvent":{
        "addEvent":"Add event",
        "eventName":"Event name",
        "source":"Source",
        "describe":"Description",
        "order":"Order"
    },
    "systemSetting":{
        "tab":{
            "deviceTypeManage":"Machine type manage",
            "maintenanceCycle":"Maintenance cycle",
            "about":"About HB",
            "unit":"Unit of temper"
        },
        "deviceTypeName":"Name",
        "describe":"Description",
        "userManual":"User manual",
        "upload":"Upload",
        "notUpload":"Not uploaded",
        "smallCycle":"Small cycle",
        "bigCycle":"Big cycle",
        "addDeviceType":"Add machine type"
    },
    "button":{
        "all":"All",
        "deleteBatch":"Delete batch",
        "delete":"Delete",
        "return":"Return",
        "search":"Search",
        "detail":"Detail",
        "save":"Save",
        "edit":"Edit",
        "add":"Add",
        "look":"Look",
        "unbind":"Unbind",
        "addMaintain":"Add maintain",
        "qrCode":"Qr code",
        "changePwd":"Change pwd",
        "cancel":"Cancel",
        "export":"Export json",
        "import":"Import",
        "ascending":"Ascending",
        "descending":"Descending",
        "addDevice":"Add",
        "upload":"Upload",
        "lookCup":"Look  cup",
        "lookChart":"Look  curve",
        "deleteChart":"Delete curve",
        "addPoint":"Add point",
        "clearAll":"Empty",
        "saveChart":"Save curve",
        "exportLog": 'Export log'
    },
    "table":{
        "time":"Time",
        "operation":"Operation",
        "content":"Content",
        "duration":"Duration",
        "starLevel":"Star level",
        "date":"Date",
        "name":"Name",
        "selectDate":"Select date",
        "select":"Select"
    },
    "options":{
        "userSearchOptions":{
            "name":"Name",
            "phone":"Phone",
            "email":"Email"
        },
        "beanManaSearchOptions":{
            "keyword":"Keyword",
            "kind":"Species",
            "method":"Process"
        },
        "beanManaOrderOptions":{
            "stock":"Stock"
        },
        "deviceManaSearchOptions":{
            "name":"Name",
            "deviceType":"Type",
            "serino":"Serino",
            "status":"Status"
        },
        "deviceManaOrderOptions":{
            "bindTime":"Bind time",
            "runTime":"Run time",
            "hbTime":"Bake time"
        },
        "reportManaSearchOptions":{
            "name":"Name"
        },
        "reportManaOrderOptions":{
            "level":"Grade",
            "color":"Degree"
        },
        "commentManaSearchOptions":{
            "name":"Name"
        },
        "commentManaOrderOptions":{
            "score":"Score",
            "level":"Grade"
        },
        "chartTypeOptions":{
            "beanTemper":"Bean temper",
            "inletAirTemperature":"Inlet air temperature",
            "outWindTemper":"Out windtemper",
            "environmentTemper":"Enviroment temper"
        },
        "deviceSearchOptions":{
            "deviceName":"Machine name",
            "deviceNumber": "Machine model",
            "seriesNumber":'Machine no.',
            "systemSeriesNum":"Machine Serial no.",
            "status":"Status",
            "deviceType":"Type",
            "developmentTime":"Development time",
            "developmentRate":"Development rate",
            "RoR1":"RoR(TP-YP)",
            "RoR2":"RoR(YP-FC)",
            "RoR3":"RoR(FC-END)",
            "roastDuration":"Roast duration",
            "dropinTemp":"Dropin temp",
            "turningPoint":"Turning point",
            "yellowPoint":"Yellow point",
            "firstCrack":"First crack",
            "secondCrack":"Second crack",
            "end":"End",
            "process":"Process",
            "heat":"Heat",
            "airflow":"Airflow",
            "drum":"Drum",
            "mark":"Mark",
            "exportPdf":"Export pdf",
            "exprotJSON":"Exprot JSON",
            "noData":"No data available"
        },
        "deviceOrderOptions":{
            "createTime":"Createdate",
            "deviceType":"Machine type",
            "hbTime":"Roaster time",
            "runTime":"Run time"
        },
        "userChartSearchOptions":{
            "reportName":"Report name",
            "reportLevel":"Report level",
            "reportColor":"Report color"
        },
        "userChartOrderOptions":{
            "reportOrderDate":"Date",
            "reportOrderLevel":"Grade"
        },
        "beanSearchOptions":{
            "name":"Name",
            "supply":"Supply"
        },
        "beanOrderOptions":{
            "firstName":"First name",
            "stock":"Stock",
            "createTime":"Createdate"
        },
        "cupOrderOptions":{
            "firstName":"First name",
            "score":"Score"
        },
        "listTab":{
            "time":"Time",
            "name":"Name",
            "machine":"Machine",
            "star":"By star",
            "rating":"Rating",
            "create":"New",
            "model":"Model",
            "inventory":"Inventory",
            "new":"New",
            "use":"Common"
        }
    },
    "placeholder":{
        "date":"Please input date",
        "logout":"Log out"
    },
    "reportList":{
        "top10":"Top10"
    },
    protocol: `
&nbsp;&nbsp;&nbsp;&nbsp;In the process of registering as a HB user, you need to complete our registration process and sign the following agreement online by clicking Agree. Please read carefully and fully understand the terms of the agreement before clicking Agree.<br />
&nbsp;&nbsp;&nbsp;&nbsp;By clicking Agree, it means that you have read and agreed to the "HB User Registration Agreement and Software License Agreement" and "Privacy Policy".<br />
&nbsp;&nbsp;&nbsp;&nbsp;(The registration button will light up after checking, and registration will be allowed, if not checked, registration will not be allowed)<br />
&nbsp;&nbsp;&nbsp;&nbsp;User Registration Agreement and Software License Agreement<br />
&nbsp;&nbsp;&nbsp;&nbsp;Reminder terms      <br />
&nbsp;&nbsp;&nbsp;&nbsp;This software license agreement (hereinafter referred to as "this agreement") is jointly signed by you and Aiqu Coffee Technology (Ningbo) Co., Ltd. (hereinafter referred to as "we"). Before using the "iqubaker" software (hereinafter referred to as the licensed software), please read this agreement carefully, especially the terms of exemption or limitation of liability, applicable laws and dispute resolution terms. The terms of the exclusion or limitation of liability will be marked in bold and you need to read them carefully. If you have any questions about this agreement, you can consult customer service. If you agree to be bound by the terms and conditions of this agreement, you may download and install the licensed software. Due to the rapid development of the Internet, the terms set out in this agreement signed by you and us cannot completely list and cover all your rights and obligations with us, and the current agreement cannot be guaranteed to fully meet the needs of future development. If you use the licensed software, you are deemed to agree to the above agreement. If we modify this agreement or its supplementary agreement, after the terms of the agreement are modified, please read and accept the revised agreement carefully before continuing to use the licensed software. If the user does not accept the revised terms, please stop using the software and services immediately, and the user's continued use of the software and services is deemed to have accepted the revised agreement.<br />       
&nbsp;&nbsp;&nbsp;&nbsp;1. Definition    <br />
        &nbsp;&nbsp;&nbsp;&nbsp;1.1 Licensed software: refers to the software system developed by us for you to download from the download platform and only installed and used in the handheld mobile terminal of the corresponding system. The ownership and operation rights of the software and services belong to HB all.<br />
        &nbsp;&nbsp;&nbsp;&nbsp;1.2 Services: This software provides services such as binding and operating smart products for users who use the mobile smart terminal.<br />
&nbsp;&nbsp;&nbsp;&nbsp;2. Software authorization and scope<br />
        &nbsp;&nbsp;&nbsp;&nbsp;2.1HB gives users a personal, non-transferable, non-sublicensable and non-exclusive license for this software.
        &nbsp;&nbsp;&nbsp;&nbsp;2.2 The user can install, use, display and run the software on a single mobile terminal device for non-commercial purposes, and the user shall not release any data stored in the memory of any terminal device during the installation, use, and operation for commercial purposes and the short interactive data between the client and the server during the running of the software, copy, change, modify, link to run or create any derivative works.<br />
        &nbsp;&nbsp;&nbsp;&nbsp;If commercial sales, reproduction and distribution are required, such as software pre-installation and bundling, written authorization and permission from HB must be obtained.<br />
&nbsp;&nbsp;&nbsp;&nbsp;3. Software acquisition, installation and upgrade<br />
       &nbsp;&nbsp;&nbsp;&nbsp;3.1 The user should download and install this software product according to the designated website or designated method of HB. Beware of downloading this software from non-designated websites, so as to prevent mobile terminal equipment from being infected with malicious programs that can destroy user data and obtain user privacy. If the user obtains the software or the installation program with the same name as the software from a third party that is not authorized by HB, HB cannot guarantee that the software can be used normally, and is not responsible for any loss caused to you.  <br />       
       &nbsp;&nbsp;&nbsp;&nbsp;3.2 The user must select the version of the software that matches the installed terminal device, otherwise, any software problem, device problem or damage caused by the mismatch between the software and the device model shall be borne by the user.       <br />
       &nbsp;&nbsp;&nbsp;&nbsp;3.3 In order to improve the user experience and improve the service content,HB has the right to provide you with replacement, modification and upgrade versions of this software from time to time, and also has the right to charge fees for the replacement, modification or upgrade, but the fees must be obtained from you in advance consent. This software enables the "upgrade prompt" function for the user by default. Depending on the software version used by the user, iQBaker provides the user to choose whether or not to enable this function. After the release of a new version of the software,HB does not guarantee the continued availability of the old version of the software.<br />   
&nbsp;&nbsp;&nbsp;&nbsp;4. Specifications    <br />
        &nbsp;&nbsp;&nbsp;&nbsp;4.1 The user can use the software and services in accordance with this agreement on the premise of abiding by the law and this agreement, and the user shall not perform the following acts:<br />     
            &nbsp;&nbsp;&nbsp;&nbsp;4.1.1 Delete all version information on this software and other copies, and modify, delete or avoid the technical measures set by this software to protect intellectual property rights;      <br />
            &nbsp;&nbsp;&nbsp;&nbsp;4.1.2 This software prohibits reverse engineering, such as disassembly, decompilation or other attempts to obtain the source code of this software;      <br />
            &nbsp;&nbsp;&nbsp;&nbsp;4.1.3 By modifying or falsifying the instructions, data, adding, deleting, changing the functions or operating effects of the software, or operating or disseminating the software and methods used for the above purposes to the public, regardless of whether these acts are commercial purpose;  <br /> 
            &nbsp;&nbsp;&nbsp;&nbsp;4.1.4 Use this software to conduct any behaviors that endanger network security, including but not limited to: using unlicensed data or entering unlicensed servers/accounts; accessing public networks or other people's operating systems without permission and deleting or modifying them , increase storage information; attempt to probe, scan, test the weaknesses of the software's system or network without permission or other behaviors that damage network security; attempt to interfere with or destroy the normal operation of the software system or website, intentionally spread malicious programs or viruses and other behaviors that disrupt and interfere with normal network information services; forge TCP/IP packet names or partial names; <br />     
            &nbsp;&nbsp;&nbsp;&nbsp;4.1.5 Users log in to or use the software and services through third-party compatible software or systems not developed, authorized or recognized by HB, or create, publish, and disseminate the above tools;        <br />
            &nbsp;&nbsp;&nbsp;&nbsp;4.1.6 Without the written consent of HB, the user conducts the software and its information without authorization, including but not limited to the following acts: use, rent, lend, copy, modify, link, reprint, compile, publish, publish, and establish mirror sites , develop derivative products, works, services, plug-ins, plug-ins, compatibility, interconnection, etc. related to this software without authorization;   <br />    
            &nbsp;&nbsp;&nbsp;&nbsp;4.1.7 Use this software to publish, transmit, disseminate, and store content that infringes upon others' intellectual property rights, trade secrets, and other legal rights;    <br />
            &nbsp;&nbsp;&nbsp;&nbsp;4.1.8 Use this software to publish, transmit, and disseminate advertising information and spam in batches;    <br />
            &nbsp;&nbsp;&nbsp;&nbsp;4.1.9 Other use of this software and other services provided by HB in any illegal way, for any illegal purpose, or in any way inconsistent with the use of this agreement. <br />   
        &nbsp;&nbsp;&nbsp;&nbsp;4.2 Information release specification<br />
            &nbsp;&nbsp;&nbsp;&nbsp;4.2.1 You can use this software to publish your original opinions, data, text, information, user names, pictures, personal information, audio, video files, links and other information content that are original or you have the right to express. You must ensure that you own the intellectual property rights of the information you upload or have been legally authorized, and that your use of the software and services does not infringe the legitimate rights and interests of any third party.<br />        
            &nbsp;&nbsp;&nbsp;&nbsp;4.2.2 You are required to comply with local laws and regulations when using this software.     <br />
            &nbsp;&nbsp;&nbsp;&nbsp;4.2.3 When using this software, you shall not use this software to engage in the following acts, including but not limited to:    <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;4.2.3.1 Produce, reproduce, publish, disseminate and store content that violates local laws and regulations;<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;4.2.3.2 Publish, transmit, disseminate, and store content that infringes upon the legal rights of others such as reputation, portrait, intellectual property, and trade secrets; <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;4.2.3.3 Fabricate facts, conceal the truth to mislead or deceive others;<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;4.2.3.4 Publishing, legend, dissemination of advertising information and spam;<br />  
          &nbsp;&nbsp;&nbsp;&nbsp;4.2.4 Without the permission of HB, you are not allowed to conduct any commercial activities such as publishing advertisements and selling goods in this software.<br />
       &nbsp;&nbsp;&nbsp;&nbsp;4.3 You understand and agree  <br />
           &nbsp;&nbsp;&nbsp;&nbsp;4.3.1 HB will determine whether the user is suspected of violating the above-mentioned usage specifications, and suspend or terminate your license or take other restrictive measures that can be taken in accordance with this agreement according to the determination result;      <br />   
           &nbsp;&nbsp;&nbsp;&nbsp;4.3.2 HB will directly delete the information published by the user that is suspected of illegal or suspected of infringing the legal rights of others or this agreement when using the licensed software;      <br />
           &nbsp;&nbsp;&nbsp;&nbsp;4.3.3 If the user's violation of the above-mentioned usage rules causes damage to a third party, you need to bear the legal responsibility in your own name independently, and you should ensure that HB is free from any loss or increased expenses; <br />
           &nbsp;&nbsp;&nbsp;&nbsp;4.3.4 If the user violates the relevant legal provisions or agreements and causes HB to suffer losses, or is claimed by a third party, or is punished by the administrative authority, the user shall compensate iqubaker for the losses and ( or) costs incurred, including reasonable attorneys'fees, investigation costs.<br />
&nbsp;&nbsp;&nbsp;&nbsp;5. Service Risks and Disclaimer<br />
      &nbsp;&nbsp;&nbsp;&nbsp;5.1 Users must equip their own mobile terminal equipment to access the Internet, and bear the relevant expenses such as personal mobile terminal equipment Internet access or communication fees and information fees charged by third parties.  <br />
          &nbsp;&nbsp;&nbsp;&nbsp;5.2 HB and its partners are not responsible for all losses suffered by users due to third parties such as communication line failures, technical problems, network, mobile terminal equipment failures, system instability and other force majeure reasons.   <br />
          &nbsp;&nbsp;&nbsp;&nbsp;5.3 This software, like most Internet software, is affected by differences in factors including but not limited to user reasons, network service quality, social environment, etc., and may be disturbed by various security issues. Harassment in real life; other software downloaded and installed by users or other websites visited contain viruses such as "Trojan horses", which threaten the security of user's terminal equipment information and data, and then affect the normal use of this software, etc. Users should strengthen the awareness of information security and user data protection, and pay attention to strengthening password protection to avoid losses and harassment.       <br />
         &nbsp;&nbsp;&nbsp;&nbsp;5.4 When the user uses the software or requests iqubaker to provide specific services, the software may call a third-party system or third-party software to support the user's use or access, and the results of the use or access are provided by the third party, HB does not guarantee the safety, accuracy, effectiveness and other uncertain risks of the results achieved through third-party systems or third-party software support, and HB shall not be liable for any disputes and damages arising therefrom. .    <br />
         &nbsp;&nbsp;&nbsp;&nbsp;5.5 HB especially reminds users that iqubaker has the right to modify or interrupt the service at any time without notifying users in order to protect the company's autonomy in business development and adjustment. The right to interrupt the service is not responsible to the user or any third party.      <br />
         &nbsp;&nbsp;&nbsp;&nbsp;5.6 Except as clearly stipulated by laws and regulations, we will do our best to ensure that the software and its related technologies and information are safe, effective, accurate and reliable. However, due to the limitations of existing technology, users understand that HB cannot This is guaranteed.  <br />
         &nbsp;&nbsp;&nbsp;&nbsp;5.7 Compensation for personal injury or incidental and indirect economic damage caused by or related to any of the following situations, including but not limited to loss of profit, loss of data, damages for business interruption or other commercial damages Compensation or loss shall be borne by the user:    <br /> 
            &nbsp;&nbsp;&nbsp;&nbsp;5.7.1 Use or failure to use the Licensed Software;       <br />
            &nbsp;&nbsp;&nbsp;&nbsp;5.7.2 Unauthorized use of software by third parties or alteration of user data;  <br />        
            &nbsp;&nbsp;&nbsp;&nbsp;5.7.3 Expenses and losses incurred by the user's use of the software;         <br />
            &nbsp;&nbsp;&nbsp;&nbsp;5.7.4 User's misunderstanding of the software;           <br />
            &nbsp;&nbsp;&nbsp;&nbsp;5.7.5 Other software-related losses caused by reasons other than HB<br />
        &nbsp;&nbsp;&nbsp;&nbsp;5.8 Any personal or economic injury or loss caused or likely to be caused by the behavior between the user and other users of the software through the software due to your being misled or deceived shall be borne by the faulty party in accordance with the law.   <br />  
&nbsp;&nbsp;&nbsp;&nbsp;6. Intellectual Property Statement      <br />
        &nbsp;&nbsp;&nbsp;&nbsp;6.1 HB is the owner of the intellectual property rights of this software, all copyrights, trademark rights, patent rights, trade secrets and other intellectual property rights of this software, as well as all information content related to this software (including but not limited to text, pictures, etc.) , audio, video, diagrams, interface design, layout framework, related data or electronic documents, etc.) are protected by your local laws and regulations and corresponding international treaties, and HB enjoys the above intellectual property rights.<br />
        &nbsp;&nbsp;&nbsp;&nbsp;6.2 Without the written consent of HB, users shall not implement, utilize or transfer the above intellectual property rights by themselves or license any third party for any commercial or non-commercial purpose. HB reserves the right to pursue legal responsibility for the above acts.<br />
        &nbsp;&nbsp;&nbsp;&nbsp;Privacy Policy<br />
&nbsp;&nbsp;&nbsp;&nbsp;We promise you      <br />
&nbsp;&nbsp;&nbsp;&nbsp;This Privacy Policy sets out how iqubaker and its affiliates (hereinafter referred to as "we") collect, use, disclose, process and protect the information you provide to us through HB APP when you use our products and services. If we ask you to provide certain information in order to verify your identity when using HB products and services, we will use this information strictly in accordance with this Privacy Policy and/or our User Terms and Conditions.<br />
&nbsp;&nbsp;&nbsp;&nbsp;This Privacy Policy has been developed with your needs in mind; it is important that you fully understand our personal data collection and use practices, and that you are confident that you ultimately control all personal information provided to HB.     <br />
&nbsp;&nbsp;&nbsp;&nbsp;In this Privacy Policy, "personal information" refers to all data that can directly or indirectly identify a particular individual through information about that individual, or when combined with other information about that individual that HB has access to . Such personal information includes, but is not limited to, information you provide or upload and device information.    <br />
&nbsp;&nbsp;&nbsp;&nbsp;By using HB's products and services or otherwise complying with the law of use, you represent that you have read and accepted all terms described in this Privacy and Policy, including any changes we make periodically. In compliance with usage laws, including local data protection laws, we will seek your explicit consent for the processing of certain categories of personal data. Additionally, we are committed to protecting the privacy, confidentiality and security of your personal information in compliance with applicable laws, including your local data protection laws. At the same time we are committed to ensuring that all our employees and agents meet these obligations.   <br /> 
&nbsp;&nbsp;&nbsp;&nbsp;In the end, all we want is to bring the best experience to our users.<br />
`
}
